/* eslint-disable array-callback-return */
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import Notifications from "./Notifications";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Layout = props => {
	// eslint-disable-next-line no-unused-vars
	const { meta, ...state } = useSelector(state => state);
	const permissions = useSelector(state => state.auth.permissions);

	return (
		<div className="main-wrapper">
			<Sidebar />
			<div className="content-wrapper" id="content-wrapper">
				<Header breadcrumbTitle={meta.breadcrumb} />
				<Notifications />
				<div className="content">
					<div className="page-meta">
						<h1 className="main-title">{meta.title}</h1>
						{meta.button.permissions &&
							meta.button.permissions.map(per => {
								if (permissions.includes(per) && meta.button.show) {
									return (
										<Link
											to={meta.button.link}
											className="bt bt-success"
											style={{
												textDecoration: "none",
											}}
										>
											{meta.button.text}
										</Link>
									);
								}
							})}
					</div>
					{props.children}
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default Layout;
